// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WH-z","twoColumnImage":"XH-z"};